import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type CartToastFrameProps = {
  desktopContent: ReactNode;
  mobileContent?: ReactNode;
  icon: ReactNode;
  onClick: () => void;
  isActive?: boolean;
  ariaLabel?: string;
};

export default function CartToastFrame({
  desktopContent,
  mobileContent,
  icon,
  onClick,
  isActive = false,
  ariaLabel,
}: CartToastFrameProps) {
  return (
    <div className="mx-auto w-full px-6">
      <button
        type="button"
        onClick={onClick}
        aria-label={ariaLabel}
        className={cn(
          "pointer-events-auto flex w-full items-center justify-between gap-4 rounded-lg border p-4 text-left transition-colors",
          isActive
            ? "border-[#dbdbdb] bg-[#f5f3ef]"
            : "border-[#dbdbdb] bg-white hover:border-[#1f2022]",
        )}
      >
        <span className="font-trimMono text-[14px] uppercase leading-[1.6] tracking-[0.42px] text-[#1f2022]">
          <span className={cn(mobileContent && "hidden md:inline")}>
            {desktopContent}
          </span>
          {mobileContent && <span className="md:hidden">{mobileContent}</span>}
        </span>
        {icon}
      </button>
    </div>
  );
}
